// e3-product-carousel.js
// Relocated 2026-06-23 from e3-custom.js (verbatim). Drives the dynamic
// left/right scroll-fade overlays on the "Popular Models / Popular Categories"
// chevron tab navigation (.type-style--tabs-carousel). CSS partner:
// assets/e3-product-carousel.css.

// Popular Models — dynamic scroll fades for chevron tab bar
(function () {
  function initChevronFades() {
    document.querySelectorAll('.type-style--tabs-carousel').forEach(function (section) {
      var wrapper = section.querySelector('.tabs-product-header-wrapper');
      var track   = section.querySelector('.tabs-product-header');
      if (!wrapper || !track) return;

      function update() {
        var s   = track.scrollLeft;
        var max = track.scrollWidth - track.clientWidth;
        wrapper.classList.toggle('e3-fade-left',      s > 8);
        wrapper.classList.toggle('e3-fade-right-end', s >= max - 8);
      }

      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChevronFades);
  } else {
    initChevronFades();
  }
}());
